import { motion } from "framer-motion";
import { Award } from "lucide-react";
import { WeldingTorch } from "@/components/site/DecorativeBG";

const CERTS = [
  {
    name: "ISO 9001:2015",
    body: "Quality Management System certified for design, manufacturing, sourcing and global export.",
    tag: "Quality Management",
  },
  {
    name: "IATF 16949:2016",
    body: "Automotive industry quality standard — applied to our production planning, control plans and PPAP.",
    tag: "Automotive Standard",
  },
  {
    name: "VDA 6.3",
    body: "Process audit standard adopted by European OEMs — applied across our key partner facilities.",
    tag: "OEM Audit",
  },
];

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="relative py-24 lg:py-32 bg-brand-bg overflow-hidden"
    >
      <WeldingTorch className="top-8 right-4 lg:right-16 hidden md:block" opacity={0.42} bounce />
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-rule" />
            <span className="eyebrow">Certifications</span>
          </div>
          <h2 className="h-section">
            Certified.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {CERTS.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`cert-card-${i}`}
              className="relative bg-white border border-gray-200 p-10 hover:shadow-2xl lift-on-hover group overflow-hidden"
            >
              <div className="absolute -top-12 -right-12 h-40 w-40 rounded-full bg-brand-orange/10 blur-2xl group-hover:bg-brand-orange/20 transition" />
              <div className="relative">
                <div className="h-14 w-14 flex items-center justify-center bg-brand-navy text-white">
                  <Award className="h-6 w-6" />
                </div>
                <div className="mt-8 text-[11px] uppercase tracking-[0.22em] text-brand-orange">
                  {c.tag}
                </div>
                <div className="mt-2 font-heading font-extrabold text-2xl text-brand-navy">
                  {c.name}
                </div>
                <p className="mt-4 text-brand-text/70 leading-relaxed">
                  {c.body}
                </p>
                <div className="mt-8 flex items-center justify-between text-[11px] uppercase tracking-[0.22em] text-brand-text/50">
                  <span>Audit-Ready</span>
                  <span className="h-px w-10 bg-brand-orange" />
                  <span>Certified</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
